import React, { useState, useEffect } from "react";
import MemberLogin from "./member/MemberLogin";
import AdminPanel from "./member/AdminPanel";
import UserSoalProfiles from "./member/UserSoalProfiles";
import { clearAuthDisplay, setAuthDisplay } from "../authDisplay";

const API_BASE =
    process.env.REACT_APP_API_BASE ??
    (process.env.NODE_ENV === "production" ? "" : "http://localhost:5000");

export default function MemberPage() {
    const [role, setRole] = useState(null);
    const [adminPreview, setAdminPreview] = useState(false);
    const [checkingSession, setCheckingSession] = useState(true);
    const wantsMembersView = () => {
        try {
            return new URLSearchParams(window.location.search).get("view") === "members";
        } catch {
            return false;
        }
    };

    useEffect(() => {
        let timer;
        let active = true;

        const restoreSession = async () => {
            try {
                const res = await fetch(`${API_BASE}/api/session`);
                const data = await res.json();
                if (!active) return;

                if (!res.ok || !data.ok) {
                    localStorage.removeItem("role");
                    localStorage.removeItem("idname");
                    localStorage.removeItem("admin_preview_mode");
                    clearAuthDisplay();
                    setAdminPreview(false);
                    setRole(null);
                    return;
                }

                const savedRole = data.role || "user";
                localStorage.setItem("role", savedRole);
                localStorage.setItem("idname", data.idname || "");
                setAuthDisplay(data);
                setRole(savedRole);
                setAdminPreview(
                    (savedRole === "admin" || savedRole === "comelec") &&
                    (wantsMembersView() || localStorage.getItem("admin_preview_mode") === "yes")
                );

                if (data.exp) {
                    const timeout = data.exp * 1000 - Date.now();
                    if (timeout > 0) {
                        timer = setTimeout(async () => {
                            await fetch(`${API_BASE}/api/logout`, { method: "POST" }).catch(() => {});
                            localStorage.removeItem("role");
                            localStorage.removeItem("idname");
                            localStorage.removeItem("admin_preview_mode");
                            clearAuthDisplay();
                            setAdminPreview(false);
                            setRole(null);
                            window.location.href = "/";
                        }, timeout);
                    }
                }
            } catch {
                if (!active) return;
                setAdminPreview(false);
                setRole(null);
            } finally {
                if (active) setCheckingSession(false);
            }
        };

        restoreSession();
        return () => {
            active = false;
            if (timer) clearTimeout(timer);
        };
    }, []);

    const handleLoginSuccess = (result) => {
        const newRole = result?.role || "user";
        setRole(newRole);
        setAdminPreview(false);
        localStorage.setItem("role", newRole);
        localStorage.setItem("idname", result?.idname || "");
        localStorage.removeItem("admin_preview_mode");
        setAuthDisplay(result);
    };

    if (checkingSession) return null;
    if (!role) return <MemberLogin onSuccess={handleLoginSuccess} />;
    if ((role === "admin" || role === "comelec") && !adminPreview) {
        return (
            <AdminPanel
                role={role}
                onPreview={() => {
                    localStorage.setItem("admin_preview_mode", "yes");
                    setAdminPreview(true);
                }}
            />
        );
    }
    return (
        <UserSoalProfiles
            role={role}
            isAdminPreview={(role === "admin" || role === "comelec") && adminPreview}
            onExitPreview={() => {
                localStorage.removeItem("admin_preview_mode");
                setAdminPreview(false);
            }}
        />
    );
}
